<template>
  <div>
    <a-form layout="inline" :form="form" @submit="handleSearch" style="margin-bottom: 16px">
      <a-form-item label="账期">
        <a-month-picker
          v-decorator="['carrier_month']"
          placeholder="请选择年月"
          style="width: 140px"
        />
      </a-form-item>
      <a-form-item label="维度">
        <a-radio-group v-model="dimension" @change="onDimensionChange">
          <a-radio-button value="carrier_product">运营商套餐</a-radio-button>
          <a-radio-button value="agent_product">客户套餐</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <template v-if="dimension === 'carrier_product'">
      <a-form-item label="运营商">
          <a-select
            allow-clear
            :value="filterCarrierType"
            placeholder="全部运营商"
            style="width: 140px"
            @change="changeFilterCarrier"
          >
            <a-select-option v-for="item in carrierTypeOptions" :key="item.value" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="运营商套餐">
          <a-select
            show-search
            allow-clear
            option-filter-prop="children"
            :disabled="!filterCarrierType"
            :loading="loadingCarrierProductOptions"
            :value="filterCarrierProductId"
            :placeholder="filterCarrierType ? '全部套餐' : '请先选择运营商'"
            style="width: 220px"
            @change="changeFilterCarrierProduct"
          >
            <a-select-option v-for="item in carrierProductOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <template v-else>
        <a-form-item label="客户">
          <a-select
            show-search
            allow-clear
            :filter-option="false"
            :value="filterTopAgentId"
            placeholder="搜索一级客户"
            style="width: 200px"
            @search="searchFilterAgents"
            @change="changeFilterAgent"
          >
            <a-select-option v-for="item in filterAgentOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="客户套餐">
          <a-select
            show-search
            allow-clear
            option-filter-prop="children"
            :disabled="!filterTopAgentId"
            :loading="loadingProductOptions"
            :value="filterProductId"
            :placeholder="filterTopAgentId ? '全部套餐' : '请先选择客户'"
            style="width: 220px"
            @change="changeFilterProduct"
          >
            <a-select-option v-for="item in productOptions" :key="item.id" :value="item.product_id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <a-form-item>
        <a-button type="primary" html-type="submit">查询</a-button>
        <a-button style="margin-left: 8px" html-type="button" @click="exportData">导出</a-button>
      </a-form-item>
    </a-form>
    <div style="margin-bottom: 12px; color: rgba(0, 0, 0, 0.45)">
      先选择统计维度。运营商套餐只按运营商及其套餐筛选；客户套餐只按一级客户及其套餐筛选。两套条件不会一起生效。
    </div>

    <a-table
      :columns="columns"
      :data-source="tableData"
      :loading="loading"
      :pagination="false"
      :locale="{ emptyText: emptyText }"
      :row-class-name="rowClassName"
      row-key="rowKey"
      size="middle"
    />
  </div>
</template>

<script>
import { findSimCardMonthCostStatistics, exportSimCardMonthCostStatistics } from '@/api/sim_card_month_cost'
import { exportExcel } from '@/api/excel'
import { findAgentOptions } from '@/api/agent'
import { findAgentsProductsOptions } from '@/api/agents_product'
import { findCarrierProductOptionsByCarrierType } from '@/api/carrier_product'
import { findCarrierTypeOptions } from '@/api/common_options'
import { formatYearMonth } from '@/utils/time'

const carrierProduct = 'carrier_product'
const agentProduct = 'agent_product'

export default {
  name: 'SimCardMonthCostStatistics',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      searched: false,
      dimension: carrierProduct,
      tableData: [],
      carrierTypeOptions: findCarrierTypeOptions(),
      filterCarrierType: undefined,
      filterCarrierProductId: undefined,
      carrierProductOptions: [],
      loadingCarrierProductOptions: false,
      filterTopAgentId: undefined,
      filterAgentOptions: [],
      filterProductId: undefined,
      productOptions: [],
      loadingProductOptions: false,
      agentSearchKeyword: ''
    }
  },
  computed: {
    emptyText() {
      return this.searched ? '该账期尚未完成统计' : '请选择账期查询'
    },
    columns() {
      const groupTitle = this.dimension === agentProduct ? '客户' : '运营商'
      const itemTitle = this.dimension === agentProduct ? '客户套餐' : '运营商套餐'
      return [
        { title: '账期月', dataIndex: 'carrier_month' },
        { title: groupTitle, dataIndex: 'group_name' },
        { title: itemTitle, dataIndex: 'item_name' },
        { title: '成本合计', dataIndex: 'cost_amount' }
      ]
    }
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      const carrierMonth = formatYearMonth(this.form.getFieldValue('carrier_month'))
      if (!carrierMonth) {
        this.$message.warning('请选择账期')
        return
      }
      this.load(carrierMonth)
    },
    exportData() {
      const carrierMonth = formatYearMonth(this.form.getFieldValue('carrier_month'))
      if (!carrierMonth) {
        this.$message.warning('请选择账期')
        return
      }
      exportSimCardMonthCostStatistics(this.currentFilters(carrierMonth)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    },
    onDimensionChange() {
      const carrierMonth = formatYearMonth(this.form.getFieldValue('carrier_month'))
      if (!carrierMonth || !this.searched) {
        this.tableData = []
        this.searched = false
        return
      }
      this.load(carrierMonth)
    },
    currentFilters(carrierMonth) {
      const query = {
        carrier_month: carrierMonth,
        dimension: this.dimension
      }
      if (this.dimension === carrierProduct) {
        if (this.filterCarrierType) {
          query.carrier_type = this.filterCarrierType
        }
        if (this.filterCarrierProductId) {
          query.carrier_product_id = this.filterCarrierProductId
        }
        return query
      }
      if (this.filterTopAgentId) {
        query.top_agent_id = this.filterTopAgentId
      }
      if (this.filterProductId) {
        query.product_id = this.filterProductId
      }
      return query
    },
    changeFilterCarrier(value) {
      this.filterCarrierProductId = undefined
      this.carrierProductOptions = []
      if (value === undefined || value === null || value === '') {
        this.filterCarrierType = undefined
        return
      }
      this.filterCarrierType = value
      this.fetchCarrierProductOptions(value)
    },
    changeFilterCarrierProduct(value) {
      if (value === undefined || value === null || value === '') {
        this.filterCarrierProductId = undefined
        return
      }
      this.filterCarrierProductId = value
    },
    fetchCarrierProductOptions(carrierType) {
      this.loadingCarrierProductOptions = true
      findCarrierProductOptionsByCarrierType(carrierType).then((res) => {
        if (res.code === 0 && this.filterCarrierType === carrierType) {
          this.carrierProductOptions = res.data || []
        }
        this.loadingCarrierProductOptions = false
      }).catch(() => {
        this.loadingCarrierProductOptions = false
      })
    },
    searchFilterAgents(name) {
      const keyword = this.$lodash.trim(name)
      this.agentSearchKeyword = keyword
      if (!keyword) {
        this.filterAgentOptions = []
        return
      }
      findAgentOptions({ name: keyword }).then((res) => {
        if (res.code === 0 && this.agentSearchKeyword === keyword) {
          this.filterAgentOptions = res.data || []
        }
      })
    },
    changeFilterAgent(value) {
      this.filterProductId = undefined
      this.productOptions = []
      if (value === undefined || value === null || value === '') {
        this.filterTopAgentId = undefined
        return
      }
      this.filterTopAgentId = value
      this.fetchProductOptions(value)
    },
    changeFilterProduct(value) {
      if (value === undefined || value === null || value === '') {
        this.filterProductId = undefined
        return
      }
      this.filterProductId = value
    },
    fetchProductOptions(agentId) {
      this.loadingProductOptions = true
      findAgentsProductsOptions({ agent_id: agentId, include_ineffective: true }).then((res) => {
        if (res.code === 0 && this.filterTopAgentId === agentId) {
          this.productOptions = res.data || []
        }
        this.loadingProductOptions = false
      }).catch(() => {
        this.loadingProductOptions = false
      })
    },
    load(carrierMonth) {
      this.loading = true
      findSimCardMonthCostStatistics(this.currentFilters(carrierMonth)).then((res) => {
        this.tableData = this.buildSummaryRows(res.data || [])
        this.searched = true
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    buildSummaryRows(rows) {
      const isAgent = this.dimension === agentProduct
      const groups = []
      let grand = 0
      rows.forEach((row) => {
        const amount = Number(row.cost_amount || 0)
        grand += amount
        const groupKey = isAgent ? row.top_agent_id : row.carrier_type
        const groupName = isAgent ? row.agent_name : row.carrier_type_display
        const itemKey = isAgent ? row.product_id : row.carrier_product_id
        const itemName = isAgent ? row.product_name : row.carrier_product_name
        let group = groups[groups.length - 1]
        if (!group || group.key !== groupKey) {
          group = { key: groupKey, name: groupName, amount: 0, rows: [] }
          groups.push(group)
        }
        group.amount += amount
        group.rows.push({
          rowKey: `${groupKey}-${itemKey}`,
          carrier_month: row.carrier_month,
          group_name: groupName,
          item_name: itemName,
          cost_amount: row.cost_amount,
          summary: false
        })
        group.carrierMonth = row.carrier_month
      })
      const tableData = []
      groups.forEach((group) => {
        tableData.push(...group.rows)
        tableData.push({
          rowKey: `subtotal-${group.key}`,
          carrier_month: group.carrierMonth,
          group_name: group.name,
          item_name: '小计',
          cost_amount: group.amount.toFixed(3),
          summary: true
        })
      })
      if (groups.length > 0) {
        tableData.push({
          rowKey: 'total',
          carrier_month: groups[0].carrierMonth,
          group_name: '合计',
          item_name: '',
          cost_amount: grand.toFixed(3),
          summary: true
        })
      }
      return tableData
    },
    rowClassName(record) {
      return record.summary ? 'cost-statistic-summary' : ''
    }
  }
}
</script>

<style scoped>
/deep/ .cost-statistic-summary {
  font-weight: 600;
  background: #fafafa;
}
</style>
